<template>
  <div>
    <div class="mt-4 mb-4 d-flex justify-content-between align-items-center">
      <h1 class="h1">Shipments</h1>
    </div>

    <div v-if="shipments === null" class="alert alert-secondary font-italic" role="alert">
      Loading...
    </div>
    <div v-else-if="shipments.length > 0">
      <ShipmentCard v-for="shipment in shipments" :shipment="shipment" :key="shipment.id" />
    </div>
    <div v-else class="alert alert-info" role="alert">No Shipments founds within the last 6 days</div>
  </div>
</template>

<script>
import ShipmentCard from '@/components/ShipmentCard'

import { db } from '@/shared/firebase'
import moment from 'moment'

export default {
  components: { ShipmentCard },

  data() {
    return {
      shipments: null
    }
  },
  created() {
    this.subscription = db
      .collection('shipments')
      .where(
        'timestamp.server',
        '>=',
        moment()
          .subtract(12, 'days')
          .toDate()
      )
      .onSnapshot(snapshot => {
        const shipments = snapshot.docs.map(doc => {
          return { ...doc.data(), id: doc.id }
        })

        this.shipments = shipments.length > 0 ? _.orderBy(shipments, 'timestamp.server', 'desc') : []
      })
  },
  beforeDestroy() {
    this.subscription()
  }
}
</script>
